<form [formGroup]="action_form" class="md:pe-56 md:-my-12 h-screen w-screen flex justify-center items-center">
  <div *ngIf="actual_step === 1" class="w-full text-white text-7xl flex flex-col items-center justify-center gap-y-8">
    <label class="ms-1 text-3xl text-gray-800">
      ID de la gama de trabajo
    </label>
    <div formGroupName="gama" class="relative mt-2 rounded-md shadow-sm w-1/2">
      <input type="text" class="form-control block w-full rounded-xl baction-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
        autofocus
        #gama_input
        (keyup)="fixPistolInput()"
        placeholder="ID de la gama de trabajo"
        formControlName="id"
        autocomplete="off"
      />
    </div>
    <button (click)="setGama()" class="bg-green-500 px-32 py-3 text-xl rounded-xl">
      CONFIRMAR
    </button>

    <p [ngClass]="message.status === 'success' ? 'text-green-500' : 'text-red-600'" class="text-xl">
      {{ message.text }}
    </p>
  </div>
  
  <div *ngIf="actual_step === 2" class="grid grid-cols-1 xl:grid-cols-2 gap-16 text-white text-7xl">
    <button (click)="setAction('start')" class="bg-green-500 p-32 rounded-3xl">
      INICIO
    </button>

    <button (click)="setAction('end')" class="bg-red-500 p-32 rounded-3xl">
      FIN
    </button>
  </div>

  <div *ngIf="actual_step === 3" class="grid grid-cols-1 xl:grid-cols-3 gap-16 text-white">
    <button *ngFor="let worker of workers" (click)="setWorker(worker.id)" class="bg-green-500 p-24 rounded-3xl">
      <p class="mb-6 text-7xl">
        {{worker.number}}
      </p>
      <p class="text-5xl">
        {{worker.name}}
      </p>
    </button>
  </div>
</form>

<!-- <form [formGroup]="action_form" class="space-y-6" action="#" method="POST">
  <div class="sm:grid grid-cols-3 gap-3">
    <div class="col-span-1">
      <label class="ms-1 text-sm text-gray-800">
        Nº Orden de trabajo
      </label>
      <div class="relative mt-2 rounded-md shadow-sm">
        <input type="text" name="order_number" id="order_number" class="form-control block w-full rounded-xl baction-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
          placeholder="Número de la orden de trabajo"
          formControlName="order_number"
          autocomplete="off" [ngClass]="{
            'is-invalid': action_form.controls['order_number'].invalid,
            'is-valid': action_form.controls['order_number'].valid}"
        />
      </div>
    </div>

    <div class="col-span-1">
      <label class="ms-1 text-sm text-gray-800">
        Nº Gama
      </label>
      <div class="relative mt-2 rounded-md shadow-sm">
        <input type="text" name="gama_number" id="gama_number" class="form-control block w-full rounded-xl baction-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
          placeholder="Número de la gama"
          formControlName="gama_number"
          autocomplete="off" [ngClass]="{
            'is-invalid': action_form.controls['gama_number'].invalid,
            'is-valid': action_form.controls['gama_number'].valid}"
        />
      </div>
    </div>
    
    <div class="col-span-1">
      <label class="ms-1 text-sm text-gray-800">
        Acción
      </label>
      <div class="relative mt-2 rounded-md shadow-sm">
        <select type="text" name="type" id="type" class="form-control block w-full rounded-xl baction-0 py-2 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 sm:text-sm sm:leading-6 focus:primary-ring-color outline-none appearance-none"
          placeholder="Acción"
          formControlName="type"
          autocomplete="off" [ngClass]="{
            'is-invalid': action_form.controls['type'].invalid,
            'is-valid': action_form.controls['type'].valid}"
        >
        <option value="start">Inicio</option>
        <option value="end">Final</option>
        <option value="pause">Pausar</option>
        <option value="continue">Continuar</option>
      </select>
      </div>
    </div>
  </div>


  <div class="flex justify-between py-4 gap-x-3">
    <div>
      <p class="{{ message.status === 'success' ? 'text-green-500' : 'text-red-600' }}">
        {{ message.text }}
      </p>
    </div>
    <div class="flex gap-x-3">
      <div *ngIf="action === 'create'; then Create; else Edit"></div>
      <ng-template #Create>
        <button [disabled]="form_in_progress" (click)="registerAction()" type="submit" class="primary-button flex justify-center rounded-xl px-10 py-2.5 text-base font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2">
          Registrar nueva acción
        </button>
      </ng-template>
      
      <ng-template #Edit>
        <button [disabled]="form_in_progress" (click)="updateAction()" type="submit" class="primary-button flex justify-center rounded-xl px-10 py-2.5 text-base font-semibold leading-6 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2">
          Confirmar cambios
        </button>
      </ng-template>
    </div>
  </div>
</form> -->